import { useMutation } from "@tanstack/react-query";

import { apiClient } from "../../config/apiClient";
import { API } from "../../config/apiConfig";

async function uploadCSVManagementCompanyRequest(data: FormData) {
	return await apiClient
		.put(
			API.COMMAND.ADMIN.MANAGEMENT_COMPANIES,
			{ management_companies: data },
			{
				headers: { "Content-Type": "multipart/form-data" }
			}
		)
		.then((res) => res.data);
}

export function useUploadCSVManagementCompany() {
	return useMutation({
		mutationFn: (data: FormData) => uploadCSVManagementCompanyRequest(data)
	});
}

async function updateTransfersFundsRequest(data: FormData) {
	return await apiClient
		.put(
			API.COMMAND.ADMIN.UPDATE_TRANSFERS_FUNDS,
			{ tax_exempt_funds: data },
			{
				headers: { "Content-Type": "multipart/form-data" }
			}
		)
		.then((res) => res.data);
}

export function useUpdateTransfersFunds() {
	return useMutation({
		mutationFn: (data: FormData) => updateTransfersFundsRequest(data)
	});
}
